/* eslint-disable */

export interface CaseCustomerCreateMultipartBody {
  subject?: string | null;
  description?: string | null;
  request?: string | null;
  type?: string | null;
  product?: string | null;
  topic?: string | null;
  version?: string | null;
  activeMenuItem?: string | null;
  errorMessage?: string | null;
  callbackTime?: Date | null;
  criticality?: number | null;
  billingRelevant?: boolean | null;
  file?: File | null;
}

export const fixCaseCustomerCreateMultipartBodyFromJson = (dto?: CaseCustomerCreateMultipartBody | null): void => {
  if (!dto) {
    return;
  }
  dto.callbackTime = dto.callbackTime && new Date(dto.callbackTime);
};

export const fixCaseCustomerCreateMultipartBodyToJson = (dto?: CaseCustomerCreateMultipartBody | null): void => {
  if (!dto) {
    return;
  }
};
